// 번역 데이터
const translations = {
  ko: {
    title: '서브웨이 칼로리 계산기',
    subtitle: '원하는 재료를 선택하여 영양 정보를 확인하세요',
    size: '사이즈',
    bread: '빵',
    meat: '메인',
    vegetables: '채소',
    cheese: '치즈',
    sauce: '소스',
    required: '필수',
    selected: '완료',
    select: '선택',
    nutritionFacts: '영양 정보',
    calories: '칼로리',
    carbs: '탄수화물',
    protein: '단백질',
    fat: '지방',
    sodium: '나트륨',
    nutrient: '영양소',
    amount: '함량',
    sizeInfo: '* {size} 기준',
    selectedItems: '선택한 재료',
    shareButton: '현재 선택 공유하기',
    randomButton: '랜덤 조합 만들기',
    resetButton: '모든 선택 초기화',
    currentCalories: '현재 칼로리:',
    updateNotes: '업데이트 노트',
    showUpdateNotes: '업데이트 노트 보기',
    hideUpdateNotes: '업데이트 노트 닫기',
    importantNotice: '중요 안내사항',
    dataSource: '데이터 출처',
    disclaimer: '* 영양 정보는 한국 서브웨이 공식 데이터를 기반으로 하지만, 실제 제품과 차이가 있을 수 있습니다.',
    contact: '문의 및 제보:',
    copyright: '서브웨이 칼로리 계산기',
    linkCopied: '링크가 복사되었습니다!',
    sizeSelection: '사이즈 선택',
    
    // 업데이트 노트
    updateNote1_1: '공유 기능 추가',
    updateNote1_2: '서브웨이 코리아 기준 성분 데이터 적용 (크롤링 후 AI 계산)',
    updateNote1_3: '상단바에 실시간 입력한 칼로리 정보 기록',
    updateNote1_4: 'Meat에 마우스 올리면 description 정보 표기됨',
    updateNote1_5: '한국어/영어 언어 전환 기능 추가',
    updateNote1_6: '랜덤 조합 생성 기능 추가',
    updateNote1_7: '모든 선택 초기화 기능 추가',
    updateNote0_1: '서비스 시작',
    updateNote0_2: '사이즈 추가',
    
    // 빵 종류
    white: '화이트',
    wheat: '위트',
    flat_bread: '플랫브레드',
    honey_oat: '허니오트',
    hearty_italian: '하티',
    parmesan_oregano: '파마산 오레가노',
    // 치즈 종류
    no_cheese: '선택 안함',
    american: '아메리칸 치즈',
    shredded: '슈레드 치즈',
    mozzarella: '모짜렐라 치즈',
    // 소스 종류
    no_sauce: '선택 안함',
    mayo: '마요네즈',
    sweet_onion: '스위트 어니언',
    honey_mustard: '허니 머스타드',
    ranch: '랜치',
    chipotle: '스모크 치폴레',
    olive_oil: '올리브 오일',
    vinegar: '식초',
    salt_pepper: '소금 & 후추',
    southwest: '사우스웨스트',
    horseradish: '홀스래디쉬',
    hot_chili: '핫 칠리',
    mustard: '머스타드',
    sweet_chili: '스위트 칠리',
    smoke_bbq: '스모크 바비큐',
    
    // 야채 종류
    lettuce: '양상추',
    tomatoes: '토마토',
    cucumbers: '오이',
    green_peppers: '피망',
    red_onions: '양파',
    olives: '올리브',
    jalapenos: '할라피뇨',
    pickles: '피클',
    avocado: '아보카도',
    
    // 메인 재료 종류
    ham: '햄',
    turkey: '터키',
    chicken: '치킨',
    tuna: '참치',
    roast_beef: '로스트 비프',
    meatball: '미트볼',
    steak: '스테이크',
    egg_mayo: '에그마요',
    blt: 'BLT',
    shrimp: '쉬림프',
    pulled_pork: '풀드 포크 바비큐',
    k_bbq: 'K-바비큐',
    spicy_italian: '스파이시 이탈리안',
    italian_bmt: '이탈리안 비엠티',
    turkey_bacon_egg_slice: '터키 베이컨 에그 슬라이스',
    turkey_bacon_avocado: '터키 베이컨 아보카도',
    anchang_beef_mushroom: '안창 비프&머쉬룸',
    steak_and_cheese: '스테이크 & 치즈',
    rotisserie_bbq_chicken: '로티세리 바비큐 치킨',
    anchang_beef: '안창 비프',
    spicy_shrimp: '스파이시 쉬림프',
    roast_chicken: '로스트 치킨',
    subway_club: '써브웨이 클럽',
    chicken_teriyaki: '치킨 데리야끼',
    mushroom: '머쉬룸',
    egg_slice: '에그 슬라이스',
    beggie: '베지',
    
    // 메인 재료 설명
    ham_desc: '풍부한 햄이 만들어내는 담백함을 입 안 가득 즐겨보세요!',
    turkey_desc: '건강하고 담백한 오리지날 터키 샌드위치',
    tuna_desc: '남녀노소 누구나 좋아하는 담백한 참치와 고소한 마요네즈의 완벽한 조화',
    blt_desc: '오리지널 아메리칸 스타일 베이컨의 풍미와 바삭함 그대로~',
    shrimp_desc: '탱글한 쉬림프 5마리가 그대로, 신선하고 담백한 쉬림프의 맛 그대로 즐겨보세요!',
    pulled_pork_desc: '미국 스타일의 풀드 포크 바비큐가 가득 들어간 샌드위치',
    spicy_italian_desc: '페퍼로니 & 살라미가 입안 가득, 페퍼로니의 부드러운 매콤함을 만나보세요!',
    italian_bmt_desc: '페퍼로니, 살라미 그리고 햄이 만들어내는 최상의 조화! 전세계가 사랑하는 써브웨이의 베스트셀러! Biggest Meatiest Tastiest, its\' B.M.T.',
    turkey_bacon_egg_slice_desc: '오리지날 터키에 고소한 베이컨과 담백한 에그 슬라이스까지 건강하고 든든하게',
    turkey_bacon_avocado_desc: '건강하고 담백한 오리지날 터키에 베이컨과 아보카도로 풍미가득 맛도 가득',
    anchang_beef_mushroom_desc: '부드럽고 풍미 넘치는 안창살과 담백하고 건강한 머쉬룸이 함께 어우러져 이루는 맛있는 조합의 샌드위치',
    steak_and_cheese_desc: '육즙이 쫙~풍부한 비프 스테이크의 풍미가 입안 한가득',
    rotisserie_bbq_chicken_desc: '촉촉한 바비큐 치킨의 풍미가득. 손으로 찢어 더욱 부드러운 치킨의 혁명',
    anchang_beef_desc: '안창살을 써브웨의만의 이국적인 특제 시즈닝을 더해 더 부드럽고, 더 풍미있게 즐기는 프리미엄 샌드위치',
    spicy_shrimp_desc: '탱글한 쉬림프에 이국적인 시즈닝을 더해 색다른 매콤함을 만나보세요!',
    roast_chicken_desc: '오븐에 구워 담백한 저칼로리 닭가슴살의 건강한 풍미',
    subway_club_desc: '고소한 베이컨, 담백한 터키에 햄까지 더해 완벽해진 조화를 즐겨보세요.',
    chicken_teriyaki_desc: '담백한 치킨 스트립에 달콤짭쪼름한 써브웨이 특제 데리야끼 소스와의 환상적인 만남',
    mushroom_desc: '버섯의 건강함을 그대로 담아 신선한 야채와 함께 담백하게 즐기는 샌드위치',
    egg_slice_desc: '달걀의 신선함과 담백함을 그대로 담아 맛도, 영양도 사로잡은 샌드위치를 만나보세요.',
    egg_mayo_desc: '부드러운 달걀과 고소한 마요네즈가 만나 더 부드러운 스테디셀러',
    cucumbers_desc: '화이트 빵, 오이 80g, 랜치가 제공되는 "오이밖에 없어 오이려 더 좋은 오이 샌드위치"',
    beggie_desc: '갓 구운 빵과 신선한 8가지 야채로 즐기는 깔끔한 한끼',
    
    // 중요 안내사항
    importantNotice1: '이 칼로리 계산기는 공식 Subway 계산기가 아니므로 공식 Data와 일치하지 않을 수 있습니다.',
    importantNotice2: '매장에서 성분표에 기재된 정량을 주지 않으면 해당 계산기의 Data와 일치하지 않을 수 있습니다.',
    importantNotice3: 'Meat 메뉴의 경우, 한국 서브웨이의 각 상품페이지를 참고하여 작성하였습니다.',
    importantNotice4: '한국 성분표에 공개되지 않은 데이터의 경우 호주의 성분표 데이터를 참고하였습니다.'
  },
  en: {
    title: 'Subway Calorie Calculator',
    subtitle: 'Select ingredients to check nutrition information',
    size: 'Size',
    bread: 'Bread',
    meat: 'Main',
    vegetables: 'Vegetables',
    cheese: 'Cheese',
    sauce: 'Sauce',
    required: 'Required',
    selected: 'Done',
    select: 'Select',
    nutritionFacts: 'Nutrition Facts',
    calories: 'Calories',
    carbs: 'Carbs',
    protein: 'Protein',
    fat: 'Fat',
    sodium: 'Sodium',
    nutrient: 'Nutrient',
    amount: 'Amount',
    sizeInfo: '* Based on {size}',
    selectedItems: 'Selected Items',
    shareButton: 'Share Current Selection',
    randomButton: 'Create Random Combination',
    resetButton: 'Reset All Selections',
    currentCalories: 'Current Calories:',
    updateNotes: 'Update Notes',
    showUpdateNotes: 'Show Update Notes',
    hideUpdateNotes: 'Hide Update Notes',
    importantNotice: 'Important Notice',
    dataSource: 'Data Source',
    disclaimer: '* Nutrition information is based on official Subway data, but may differ from actual products.',
    contact: 'Contact:',
    copyright: 'Subway Calorie Calculator',
    linkCopied: 'Link copied!',
    sizeSelection: 'Size Selection',
    
    // Update notes
    updateNote1_1: 'Added sharing feature',
    updateNote1_2: 'Applied Subway Korea-based ingredient data (crawled and calculated with AI)',
    updateNote1_3: 'Added real-time calorie information in the top bar',
    updateNote1_4: 'Added description information when hovering over Meat',
    updateNote1_5: 'Added Korean/English language switching feature',
    updateNote1_6: 'Added random combination generation feature',
    updateNote1_7: 'Added reset all selections feature',
    updateNote0_1: 'Service launch',
    updateNote0_2: 'Added size options',
    
    // Bread types
    white: 'White',
    wheat: 'Wheat',
    flat_bread: 'Flat Bread',
    honey_oat: 'Honey Oat',
    hearty_italian: 'Hearty Italian',
    parmesan_oregano: 'Parmesan Oregano',
    // Cheese types
    no_cheese: 'No Cheese',
    american: 'American Cheese',
    shredded: 'Shredded Cheese',
    mozzarella: 'Mozzarella Cheese',
    // Sauce types
    no_sauce: 'No Sauce',
    mayo: 'Mayonnaise',
    sweet_onion: 'Sweet Onion',
    honey_mustard: 'Honey Mustard',
    ranch: 'Ranch',
    chipotle: 'Smoke Chipotle',
    olive_oil: 'Olive Oil',
    vinegar: 'Vinegar',
    salt_pepper: 'Salt & Pepper',
    southwest: 'Southwest',
    horseradish: 'Horseradish',
    hot_chili: 'Hot Chili',
    mustard: 'Mustard',
    sweet_chili: 'Sweet Chili',
    smoke_bbq: 'Smoke BBQ',
    
    // Vegetable types
    lettuce: 'Lettuce',
    tomatoes: 'Tomatoes',
    cucumbers: 'Cucumbers',
    green_peppers: 'Green Peppers',
    red_onions: 'Red Onions',
    olives: 'Olives',
    jalapenos: 'Jalapenos',
    pickles: 'Pickles',
    avocado: 'Avocado',
    
    // Main ingredient types
    ham: 'Ham',
    turkey: 'Turkey',
    chicken: 'Chicken',
    tuna: 'Tuna',
    roast_beef: 'Roast Beef',
    meatball: 'Meatball',
    steak: 'Steak',
    egg_mayo: 'Egg Mayo',
    blt: 'BLT',
    shrimp: 'Shrimp',
    pulled_pork: 'Pulled Pork BBQ',
    k_bbq: 'K-BBQ',
    spicy_italian: 'Spicy Italian',
    italian_bmt: 'Italian B.M.T.',
    turkey_bacon_egg_slice: 'Turkey Bacon Egg Slice',
    turkey_bacon_avocado: 'Turkey Bacon Avocado',
    anchang_beef_mushroom: 'Anchang Beef & Mushroom',
    steak_and_cheese: 'Steak & Cheese',
    rotisserie_bbq_chicken: 'Rotisserie BBQ Chicken',
    anchang_beef: 'Anchang Beef',
    spicy_shrimp: 'Spicy Shrimp',
    roast_chicken: 'Roast Chicken',
    subway_club: 'Subway Club',
    chicken_teriyaki: 'Chicken Teriyaki',
    mushroom: 'Mushroom',
    egg_slice: 'Egg Slice',
    beggie: 'Veggie',
    
    // Main ingredient descriptions
    ham_desc: 'Enjoy the mild flavor of ham in every bite!',
    turkey_desc: 'Healthy and mild original turkey sandwich',
    tuna_desc: 'The perfect combination of mild tuna and savory mayonnaise that everyone loves',
    blt_desc: 'The flavor and crispiness of original American-style bacon as it is~',
    shrimp_desc: 'Enjoy 5 plump shrimps as they are, with the fresh and mild taste of shrimp!',
    pulled_pork_desc: 'A sandwich filled with American-style pulled pork barbecue',
    spicy_italian_desc: 'Pepperoni & salami fill your mouth, experience the soft spiciness of pepperoni!',
    italian_bmt_desc: 'The perfect harmony of pepperoni, salami and ham! Subway\'s bestseller loved worldwide! Biggest Meatiest Tastiest, it\'s B.M.T.',
    turkey_bacon_egg_slice_desc: 'Original turkey with savory bacon and mild egg slice for a healthy and hearty meal',
    turkey_bacon_avocado_desc: 'Healthy and mild original turkey with bacon and avocado for full flavor and taste',
    anchang_beef_mushroom_desc: 'A delicious combination of tender and flavorful beef brisket with mild and healthy mushrooms',
    steak_and_cheese_desc: 'A mouthful of juicy beef steak flavor',
    rotisserie_bbq_chicken_desc: 'Full of moist barbecue chicken flavor. Hand-pulled for even more tender chicken revolution',
    anchang_beef_desc: 'A premium sandwich with beef brisket enhanced with Subway\'s exotic special seasoning for a more tender and flavorful experience',
    spicy_shrimp_desc: 'Add exotic seasoning to plump shrimp for a different kind of spiciness!',
    roast_chicken_desc: 'The healthy flavor of oven-roasted, low-calorie chicken breast',
    subway_club_desc: 'Enjoy the perfect harmony with savory bacon, mild turkey, and ham added.',
    chicken_teriyaki_desc: 'A fantastic combination of mild chicken strips with Subway\'s special sweet and savory teriyaki sauce',
    mushroom_desc: 'A sandwich that captures the healthiness of mushrooms and enjoys them mildly with fresh vegetables',
    egg_slice_desc: 'Meet a sandwich that captures the freshness and mildness of eggs for both taste and nutrition.',
    egg_mayo_desc: 'A steady seller that becomes even softer when soft eggs meet savory mayonnaise',
    cucumbers_desc: 'White bread, 80g of cucumber, and ranch dressing - "The cucumber sandwich that\'s better because it\'s only cucumber"',
    beggie_desc: 'A clean meal with freshly baked bread and 8 fresh vegetables',
    
    // Important notices
    importantNotice1: 'This calorie calculator is not an official Subway calculator and may not match official data.',
    importantNotice2: 'If the store does not provide the amount specified in the ingredient table, it may not match the data of this calculator.',
    importantNotice3: 'For meat menus, we referred to each product page of Subway Korea.',
    importantNotice4: 'For data not disclosed in the Korean ingredient table, we referred to the Australian ingredient table data.'
  }
};

export default translations;